import { ComponentProps, JSX } from "solid-js";
import c from "class-c";

import UObject from "@repo/utils/UObject";

import styles from "./CheckAnimation.module.scss";

declare namespace CheckAnimation {
  type Props = UObject.Override<
    ComponentProps<"span">,
    {
      color?: JSX.CSSProperties["color"];
      size?: JSX.CSSProperties["width"];
      show?: boolean;
    }
  >;
}

function CheckAnimation({
  class: className,
  size = "1em",
  show = true,
  color = "currentcolor",
  ...props
}: D<CheckAnimation.Props>) {
  return (
    <span class={c`${styles["check-animation"]} ${className}`} {...props}>
      <svg viewBox="5 5 40 40" width={size} height={size}>
        {show && (
          <path
            fill="none"
            d="M14.1 27.2l7.1 7.2 16.7-16.8"
            style={{ stroke: color }}
          />
        )}
      </svg>
    </span>
  );
}

export default CheckAnimation;
